import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import DeviceForm from "../../component/Device/DeviceForm";

class DeviceFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de Dispositivos" to="/list/devices"/>,
      < BreadcrumbItem key={3} title="Dados do Dispositivo" active={true}/>];
    return (
        <Page title="Dados do Dispositivo" breadcrumbs={breadcrumbs}>
          <DeviceForm match={match} history={history}/>
        </Page>
    );
  }
}

export default DeviceFormPage;


// WEBPACK FOOTER //
// ./src/pages/Device/DeviceFormPage.js